import CP_LEAD from "../assets/lead/CP.svg";
import TAS_LEAD from "../assets/lead/TAS.svg";
import SOS_LEAD from "../assets/lead/SOS.svg";
import SA_LEAD from "../assets/lsa.png";
import CP_LEAD_SHORT from "../assets/lead/CP_Short.svg";
import TAS_LEAD_SHORT from "../assets/lead/TAS_Short.svg";
import SOS_LEAD_SHORT from "../assets/lead/SOS_Short.svg";
import LOGO_LEAD from "../assets/lead/leadLogo.svg";

import COL1 from "../assets/lead/Carousel1.svg";
import COL2 from "../assets/lead/Carousel2.svg";
import COL3 from "../assets/lead/Carousel3.svg";
import COL4 from "../assets/lead/Carousel4.svg";

import COL_PLUS1 from "../assets/pinnacle/Carousel1.svg";
import COL_PLUS2 from "../assets/pinnacle/Carousel2.svg";
import COL_PLUS3 from "../assets/pinnacle/Carousel3.svg";
import COL_PLUS4 from "../assets/pinnacle/Carousel4.svg";
import COL_PLUS5 from "../assets/pinnacle/Carousel5.svg";
import COL_PLUS6 from "../assets/pinnacle/Carousel6.svg";

import COL_PROPEL1 from "../assets/propel/Carousel1.svg";
import COL_PROPEL2 from "../assets/propel/Carousel2.svg";
import COL_PROPEL3 from "../assets/propel/Carousel3.svg";
import COL_PROPEL4 from "../assets/propel/Carousel4.svg";

import CP_PINNACLE from "../assets/pinnacle/CP.svg";
import TAS_PINNACLE from "../assets/pinnacle/TAS.svg";
import SOS_PINNACLE from "../assets/pinnacle/SOS.svg";
import SA_PINNACLE from "../assets/psa.png";
import CP_PINNACLE_SHORT from "../assets/pinnacle/CP_Short.svg";
import TAS_PINNACLE_SHORT from "../assets/pinnacle/TAS_Short.svg";
import SOS_PINNACLE_SHORT from "../assets/pinnacle/SOS_Short.svg";
import LOGO_PINNACLE from "../assets/pinnacle/pinnacleLogo.svg";

import CP_PROPEL from "../assets/propel/CP.svg";
import TAS_PROPEL from "../assets/propel/TAS.svg";
import SOS_PROPEL from "../assets/propel/SOS.svg";
import SA_PROPEL from "../assets/propel/Student_App.svg";
import CP_PROPEL_SHORT from "../assets/propel/CP_Short.svg";
import TAS_PROPEL_SHORT from "../assets/propel/TAS_Short.svg";
import SOS_PROPEL_SHORT from "../assets/propel/SOS_Short.svg";
import LOGO_PROPEL from "../assets/propel/propel-logo.svg";

// import STUDENT_ACTIVITY from "../assets/activity-kits-student.svg";
import SCHOOL_ACTIVITY from "../assets/lsk.png";

import STUDENT_KITS_PINNACLE from "../assets/psk 2.png";
import SCHOOL_KITS_PINNACLE from "../assets/psk.png";

import SA_DASHBOARD_PLUS from "../assets/pinnacle/SaDashboard.svg";
import SA_MENU_PLUS from "../assets/pinnacle/SaMenu.svg";
import SA_MEDIA_PLUS from "../assets/pinnacle/SaMedia.svg";
import SA_RESOURCES_PLUS from "../assets/pinnacle/SaResources.svg";
import SA_CHAPTERS_PLUS from "../assets/pinnacle/SaChapters.svg";
import SA_CONTENT_PLUS from "../assets/pinnacle/SaContent.svg";

import SA_DASHBOARD_LEAD from "../assets/lead/SaDashboard.svg";
import SA_MENU_LEAD from "../assets/lead/SaMenu.svg";
import SA_MEDIA_LEAD from "../assets/lead/SaMedia.svg";
import SA_RESOURCES_LEAD from "../assets/lead/SaResources.svg";
import SA_CHAPTERS_LEAD from "../assets/lead/SaChapters.svg";
import SA_CONTENT_LEAD from "../assets/lead/SaContent.svg";

import TEACHER_VIDEO from "../assets/teacherVideo.svg";
import STUDENT_VIDEO from "../assets/studentVideo.svg";
import ASSESSMENTS from "../assets/Assessments.svg";
import REMEDIATION from "../assets/Remediation.svg";
import {
  PINNACLE_EVS_DAY1_CH5,
  PINNACLE_MATHS_DAY3_CH2,
  PINNACLE_MATHS_DAY1_CH4,
  PINNACLE_EVS_DAY4_CH5,
  PINNACLE_SCIENCE_DAY2_CH4,
  PROPEL_EVS_DAY1_CH4,
  PROPEL_MATH_DAY6_CH3,
  PROPEL_MATH_DAY2_CH1,
  LEAD_EVS_DAY3_UNIT1,
  LEAD_MATHS_DAY2_UNIT1,
  LEAD_SCIENCE_DAY15_UNIT1,
  LEAD_MATH_DAY2_UNIT1,
  PROPEL_CLL_DAY2_CH1,
  PROPEL_NUMERACY_DAY2_CH1,
  PROPEL_UNDERSTANDING_DAY4_CH1,
  PINNACLE_LITERACY_DAY1_CH1,
  PINNACLE_NUMERACY_DAY2_CH1,
  PINNACLE_GENAWARENESS_DAY1_CH1,
  PROPEL_SCIENCE_DAY2_CH2,
  LEAD_INTCUR_DAY1_MR,
  LEAD_INTCUR_DAY1_EEVS,
  LEAD_INTCUR_DAY1_EELGA,
  LEAD_INTCUR_DAY1_EMATH,
  LEAD_INTCUR_DAY1_PY,
  // PINNACLE_ENGLISH_DAY2_CH3,
  // PINNACLE_ENGLISH_DAY1_CH4,
  // PROPEL_ENGLISH_CH3_DAY2,
} from "./lessonPlans";

export const PRODUCT_TYPE_CAPS = {
  PROPEL: "PROPEL",
  PINNACLE: "PINNACLE",
  LEAD: "LEAD",
};

export const PRODUCT_TYPE = {
  PROPEL: "Propel",
  PINNACLE: "Pinnacle+",
  LEAD: "LEAD",
};

export const TYPES = {
  CARD: "CARD",
  CARD_LINK: "CARD_LINK",
  CARD_MEDIA_IMG: "CARD_MEDIA_IMG",
  CARD_MEDIA_VIDEO: "CARD_MEDIA_VIDEO",
  CARD_MEDIA_CAROUSEL: "CARD_MEDIA_CAROUSEL",
  CARD_LESSON_PLANS: "CARD_LESSON_PLANS",
  SA_DASHBOARD: "Dashboard",
  SA_MEDIA: "Media",
  SA_CHAPTER: "Chapter",
  SA_MENU: "Menu",
  SA_CONTENT: "Content",
  SA_RESOURCES: "Resources",
  LEARNING_INDICATOR: "LEARNING_INDICATOR",
  UNORDERED_LIST: "UNORDERED_LIST",
  ICON: "ICON",
};

const getDomainName = () => {
  let domainName = PRODUCT_TYPE_CAPS.LEAD;
  try {
    // to get domain name
    domainName = window.location.hostname
      .split(".")[1]
      ?.replace("-", "")
      ?.replace("school", "")
      ?.toUpperCase();
    if (domainName === PRODUCT_TYPE_CAPS.LEAD) {
      // to get subdomain name
      const subDomain = window.location.hostname
        .split(".")[0]
        ?.split("-")
        ?.pop()
        ?.replace("school", "")
        ?.toUpperCase();
      if (subDomain?.includes(PRODUCT_TYPE_CAPS.PROPEL)) {
        domainName = PRODUCT_TYPE_CAPS.PROPEL;
      } else if (
        subDomain?.includes(
          PRODUCT_TYPE_CAPS.PINNACLE.split("+")[0].toUpperCase()
        )
      ) {
        domainName = PRODUCT_TYPE_CAPS.PINNACLE.split("+")[0];
      }
    }
  } catch {
    domainName = PRODUCT_TYPE_CAPS.LEAD;
  }
  return domainName || PRODUCT_TYPE_CAPS.LEAD;
};

export const CURRENT_DOMAIN = getDomainName();

// export const CURRENT_DOMAIN = PRODUCT_TYPE_CAPS.PROPEL;
const config = {
  ACTIVE: "",
  PROPEL: {
    ICON: "",
    TITLE: PRODUCT_TYPE.PROPEL,
    LOGO: LOGO_PROPEL,
    CURRICULUM_PEDAGOGY: CP_PROPEL,
    TEACHER_ASSISTANCE_SYSTEM: TAS_PROPEL,
    SCHOOL_OPERATION_SYSTEM: SOS_PROPEL,
    CURRICULUM_PEDAGOGY_MINI: CP_PROPEL_SHORT,
    TEACHER_ASSISTANCE_SYSTEM_MINI: TAS_PROPEL_SHORT,
    SCHOOL_OPERATION_SYSTEM_MINI: SOS_PROPEL_SHORT,
    STUDENT_APP: SA_PROPEL,
    CORE_SUBJECT: "Pearson",
    SECTION_TITLE_ASM: "Assessments",
    ASSESSMENTS: ASSESSMENTS,
    REMEDIATION: REMEDIATION,
    TAS_ASM_LINK:
      "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/media/Propel%20Digital%20Assessments.mp4",
    SOS_TEACHER_LINK:
      "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/media/Propel%20Nucleus%20Teacher%20Reports%20and%20Implementation.mp4",
    CAROUSEL: [
      {
        img: COL_PROPEL1,
      },
      {
        img: COL_PROPEL2,
      },
      {
        img: COL_PROPEL3,
      },
      {
        img: COL_PROPEL4,
      },
    ],
    CP_HEADING1: "High Quality",
    CP_HEADING2: `Curriculum & Pedagogy`,
    TAS_HEADING2: `Teacher Assistance System`,
    SOS_HEADING2: `School Operating System`,
  },
  PINNACLE: {
    ICON: "",
    TITLE: PRODUCT_TYPE.PINNACLE,
    LOGO: LOGO_PINNACLE,
    CURRICULUM_PEDAGOGY: CP_PINNACLE,
    TEACHER_ASSISTANCE_SYSTEM: TAS_PINNACLE,
    SCHOOL_OPERATION_SYSTEM: SOS_PINNACLE,
    CURRICULUM_PEDAGOGY_MINI: CP_PINNACLE_SHORT,
    TEACHER_ASSISTANCE_SYSTEM_MINI: TAS_PINNACLE_SHORT,
    SCHOOL_OPERATION_SYSTEM_MINI: SOS_PINNACLE_SHORT,
    SECTION_TITLE_ASM: "Assessments & Remediation",
    CORE_SUBJECT: "Pearson",
    TAS_ASM_LINK:
      "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/media/1.%20ASM%20%28Readymade%20and%20edit%20flow%29_default.mp4",
    TAS_ASM_DURATION: "01:36 Min",
    TAS_REMEDIAL_LINK:
      "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/media/2.%20Remedial_default.mp4",
    TAS_REMEDIAL_DURATION: "01:05 Min",
    SOS_STUDENT_LINK:
      "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/media/3.%20Student%20Dashboard%20Report%20%28Pinnacle%20and%20Lead%29_default.mp4",
    SOS_TEACHER_LINK:
      "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/media/4.%20Teacher%20Performance%20Reports_default.mp4",
    STUDENT_APP: SA_PINNACLE,
    SA_DASHBOARD: SA_DASHBOARD_PLUS,
    SA_MENU: SA_MENU_PLUS,
    SA_CHAPTERS: SA_CHAPTERS_PLUS,
    SA_MEDIA: SA_MEDIA_PLUS,
    SA_CONTENT: SA_CONTENT_PLUS,
    SA_RESOURCES: SA_RESOURCES_PLUS,
    ASSESSMENTS: ASSESSMENTS,
    REMEDIATION: REMEDIATION,
    STUDENT_ACTIVITY_LINK: "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Pinnacle%20-%20Student%20Activity%20Kit.pdf",
    SCHOOL_ACTIVITY_LINK:
      "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/pinnacle/Pinnacle%2B%20SEK%20-%20Primary%202023.pdf",
    STUDENT_ACTIVITY: STUDENT_KITS_PINNACLE,
    SCHOOL_ACTIVITY: SCHOOL_KITS_PINNACLE,
    CAROUSEL: [
      {
        img: COL_PLUS1,
      },
      {
        img: COL_PLUS2,
      },
      {
        img: COL_PLUS3,
      },
      {
        img: COL_PLUS4,
      },
      {
        img: COL_PLUS5,
      },
      {
        img: COL_PLUS6,
      },
    ],
    SA_PROTOTYPE:
      "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2F0mhcTycrfD2gE5tYLzyGD0%2FNucleus-2023%252B%3Fembed_host%3Dshare%26kind%3D%26node-id%3D12121-11981%26page-id%3D8734%253A10501%26scaling%3Dmin-zoom%26starting-point-node-id%3D12121%253A11947%26t%3DU1uLOcwNbbGgciJC-1%26type%3Ddesign%26mode%3Ddesign",
    CP_HEADING1: "Internationally Benchmarked",
    CP_HEADING2: `Curriculum & Pedagogy`,
    TAS_HEADING2: `Teacher Assistance System`,
    SOS_HEADING2: `School Operating System`,
  },
  LEAD: {
    ICON: "",
    NAME: "",
    TITLE: PRODUCT_TYPE.LEAD,
    LOGO: LOGO_LEAD,
    CURRICULUM_PEDAGOGY: CP_LEAD,
    TEACHER_ASSISTANCE_SYSTEM: TAS_LEAD,
    SCHOOL_OPERATION_SYSTEM: SOS_LEAD,
    CURRICULUM_PEDAGOGY_MINI: CP_LEAD_SHORT,
    TEACHER_ASSISTANCE_SYSTEM_MINI: TAS_LEAD_SHORT,
    SCHOOL_OPERATION_SYSTEM_MINI: SOS_LEAD_SHORT,
    STUDENT_APP: SA_LEAD,
    ASSESSMENTS: ASSESSMENTS,
    REMEDIATION: REMEDIATION,
    CORE_SUBJECT: "LEAD",
    SECTION_TITLE_ASM: "Remediation",
    TAS_REMEDIAL_LINK:
      "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/media/LEAD%20Remedials%20N1.mp4",
    SOS_STUDENT_LINK:
      "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/media/LEAD%20Student%20Performace%20Reports%20N1.mp4",
    SOS_TEACHER_LINK:
      "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/media/LEAD%20Teacher%20Performance%20Reports%20N1.mp4",
    SCHOOL_ACTIVITY_LINK:
      "https://cdn-nucleus.leadschool.in/services/leavebehind/resources/docs/Lead/SEK%20-%20Primary%202023_Box%20print.pdf",
    CAROUSEL: [
      {
        img: COL1,
      },
      {
        img: COL2,
      },
      {
        img: COL3,
      },
      {
        img: COL4,
      },
    ],
    SCHOOL_ACTIVITY: SCHOOL_ACTIVITY,
    SA_DASHBOARD: SA_DASHBOARD_LEAD,
    SA_MENU: SA_MENU_LEAD,
    SA_CHAPTERS: SA_CHAPTERS_LEAD,
    SA_MEDIA: SA_MEDIA_LEAD,
    SA_CONTENT: SA_CONTENT_LEAD,
    SA_RESOURCES: SA_RESOURCES_LEAD,
    SA_PROTOTYPE:
      "https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2F0mhcTycrfD2gE5tYLzyGD0%2FNucleus-2023%252B%3Ftype%3Ddesign%26node-id%3D12235-1331%26t%3DqzXmV9rdewzPn2y0-1%26scaling%3Dmin-zoom%26page-id%3D8734%253A10501%26starting-point-node-id%3D12235%253A1232%26show-proto-sidebar%3D1%26mode%3Ddesign",
    CP_HEADING1: "",
    CP_HEADING2: `Curriculum & Pedagogy Solution`,
    TAS_HEADING2: `Teacher Capability System`,
    SOS_HEADING2: `Academic Operating System.`,
  },
};

export const getConfig = () => config[config?.ACTIVE];

const setActive = (active) => {
  config.ACTIVE = active.split("+")[0]?.toUpperCase();
};

setActive(CURRENT_DOMAIN);

const LESSON_PLAN_PINNACLE = [
  {
    label: "Class 2",
    id: 2,
    subjects: [
      {
        label: "EVS",
        colorCode: "#DF911C",
        dayPlans: [
          {
            label: "CH 5 - Day 1",
            day: "1",
            chapter: "Chapter 5",
            component: PINNACLE_EVS_DAY1_CH5,
          },
          {
            label: "CH 5 - Day 4",
            day: "4",
            chapter: "Chapter 5",
            component: PINNACLE_EVS_DAY4_CH5,
          },
        ],
      },
      {
        label: "Maths",
        colorCode: "#D3B443",
        dayPlans: [
          {
            label: "CH 2 - Day 3",
            day: "3",
            chapter: "Chapter 2",
            component: PINNACLE_MATHS_DAY3_CH2,
          },
        ],
      },
      // {
      //   label: "English",
      //   colorCode: "#D3B443",
      //   dayPlans: [
      //     {
      //       label: "CH 3 - Day 2",
      //       day: "2",
      //       chapter: "3",
      //       component: PINNACLE_ENGLISH_DAY2_CH3,
      //     },
      //   ],
      // },
    ],
  },
  {
    label: "Class 5",
    id: 5,
    subjects: [
      {
        label: "Maths",
        colorCode: "#D3B443",
        dayPlans: [
          {
            label: "CH 4 - Day 1",
            day: "1",
            chapter: "Chapter 4",
            component: PINNACLE_MATHS_DAY1_CH4,
          },
        ],
      },
      {
        label: "Science",
        colorCode: "#9043DD",
        dayPlans: [
          {
            label: "CH 4 - Day 2",
            day: "2",
            chapter: "Chapter 4",
            component: PINNACLE_SCIENCE_DAY2_CH4,
          },
        ],
      },
      // {
      //   label: "English",
      //   colorCode: "#D3B443",
      //   dayPlans: [
      //     {
      //       label: "CH 4 - Day 1",
      //       day: "1",
      //       chapter: "4",
      //       component: PINNACLE_ENGLISH_DAY1_CH4,
      //     },
      //   ],
      // },
    ],
  },
  {
    label: "SKG",
    id: 10,
    subjects: [
      {
        label: "Literacy",
        colorCode: "#21ADCC",
        dayPlans: [
          {
            label: "Unit 1 - Day 1",
            day: "1",
            chapter: "Unit 1",
            component: PINNACLE_LITERACY_DAY1_CH1,
          },
        ],
      },
      {
        label: "Numeracy",
        colorCode: "#DB5B53",
        dayPlans: [
          {
            label: "Unit 1 - Day 2",
            day: "2",
            chapter: "Unit 1",
            component: PINNACLE_NUMERACY_DAY2_CH1,
          },
        ],
      },
      {
        label: "General Awareness",
        colorCode: "#19A937",
        dayPlans: [
          {
            label: "Unit 1 - Day 1",
            day: "1",
            chapter: "Unit 1",
            component: PINNACLE_GENAWARENESS_DAY1_CH1,
          },
        ],
      },
    ],
  },
];

const LESSON_PLAN_PROPEL = [
  {
    label: "Class 2",
    id: 2,
    subjects: [
      {
        label: "EVS",
        colorCode: "#DF911C",
        dayPlans: [
          {
            label: "CH 4 - Day 1",
            day: "1",
            chapter: "Chapter 4",
            component: PROPEL_EVS_DAY1_CH4,
          },
        ],
      },
      {
        label: "Maths",
        colorCode: "#D3B443",
        dayPlans: [
          {
            label: "CH 3 - Day 6",
            day: "6",
            chapter: "Chapter 3",
            component: PROPEL_MATH_DAY6_CH3,
          },
        ],
      },
      // {
      //   label: "English",
      //   colorCode: "#D3B443",
      //   dayPlans: [
      //     {
      //       label: "CH 3 - Day 2",
      //       day: "2",
      //       chapter: "3",
      //       component: PROPEL_ENGLISH_CH3_DAY2,
      //     },
      //   ],
      // },
    ],
  },
  {
    label: "Class 5",
    id: 5,
    subjects: [
      {
        label: "Maths",
        colorCode: "#D3B443",
        dayPlans: [
          {
            label: "CH 1 - Day 2",
            day: "2",
            chapter: "Chapter 1",
            component: PROPEL_MATH_DAY2_CH1,
          },
        ],
      },
      {
        label: "Science",
        colorCode: "#9043DD",
        dayPlans: [
          {
            component: PROPEL_SCIENCE_DAY2_CH2,
            label: "CH 2 - Day 2",
            day: "2",
            chapter: "Chapter 2",
          },
        ],
      },
    ],
  },
  {
    label: "SKG",
    id: 10,
    subjects: [
      {
        label: "Communication, Language, and Literacy",
        colorCode: "#21ADCC",
        dayPlans: [
          {
            label: "Unit 1 - Day 2",
            day: "2",
            chapter: "Unit 1",
            component: PROPEL_CLL_DAY2_CH1,
          },
        ],
      },
      {
        label: "Numeracy",
        colorCode: "#D3B443",
        dayPlans: [
          {
            label: "Unit 1 - Day 2",
            day: "2",
            chapter: "Unit 1",
            component: PROPEL_NUMERACY_DAY2_CH1,
          },
        ],
      },
      {
        label: "Understanding our World",
        colorCode: "#19A937",
        dayPlans: [
          {
            label: "Unit 1 - Day 4",
            day: "4",
            chapter: "Unit 1",
            component: PROPEL_UNDERSTANDING_DAY4_CH1,
          },
        ],
      },
    ],
  },
];

const LESSON_PLAN_LEAD = [
  {
    label: "Class 2",
    id: 2,
    subjects: [
      {
        label: "EVS",
        colorCode: "#DF911C",
        dayPlans: [
          {
            label: "Unit 1 - Day 3",
            day: "3",
            chapter: "Unit 1",
            component: LEAD_EVS_DAY3_UNIT1,
          },
        ],
      },
      {
        label: "Maths",
        colorCode: "#D3B443",
        dayPlans: [
          {
            label: "Unit 1 - Day 2",
            day: "2",
            chapter: "Unit 1",
            component: LEAD_MATHS_DAY2_UNIT1,
          },
        ],
      },
    ],
  },
  {
    label: "Class 5",
    id: 5,
    subjects: [
      {
        label: "Science",
        colorCode: "#9043DD",
        dayPlans: [
          {
            label: "Unit 1 - Day 15",
            day: "15",
            chapter: "Unit 1",
            component: LEAD_SCIENCE_DAY15_UNIT1,
          },
        ],
      },
      {
        label: "Maths",
        colorCode: "#D3B443",
        dayPlans: [
          {
            label: "Unit 1 - Day 2",
            day: "2",
            chapter: "Unit 1",
            component: LEAD_MATH_DAY2_UNIT1,
          },
        ],
      },
    ],
  },
  {
    label: "SKG",
    id: 10,
    subjects: [
      {
        label: "IC - Morning Routine",
        colorCode: "#418BD6",
        dayPlans: [
          {
            label: "Unit 1 - Day 1",
            day: "15",
            chapter: "Unit 1",
            component: LEAD_INTCUR_DAY1_MR,
          },
        ],
      },
      {
        label: "IC - Early EVS",
        colorCode: "#D3B443",
        dayPlans: [
          {
            label: "Unit 1 - Day 1",
            day: "1",
            chapter: "Unit 1",
            component: LEAD_INTCUR_DAY1_EEVS,
          },
        ],
      },
      {
        label: "IC - Early ELGA",
        colorCode: "#9043DD",
        dayPlans: [
          {
            label: "Unit 1 - Day 1",
            day: "1",
            chapter: "Unit 1",
            component: LEAD_INTCUR_DAY1_EELGA,
          },
        ],
      },
      {
        label: "IC - Early Mathelogic",
        colorCode: "#DB5B53",
        dayPlans: [
          {
            label: "Unit 1 - Day 1",
            day: "1",
            chapter: "Unit 1",
            component: LEAD_INTCUR_DAY1_EMATH,
          },
        ],
      },
      {
        label: "IC - Physical & Yoga",
        colorCode: "#19A937",
        dayPlans: [
          {
            label: "Unit 1 - Day 1",
            day: "1",
            chapter: "Unit 1",
            component: LEAD_INTCUR_DAY1_PY,
          },
        ],
      },
    ],
  },
];

const getLessonPlan = (domain) => {
  if (domain === PRODUCT_TYPE.PINNACLE || domain === PRODUCT_TYPE_CAPS.PINNACLE)
    return LESSON_PLAN_PINNACLE;
  if (domain === PRODUCT_TYPE.LEAD || domain === PRODUCT_TYPE_CAPS.LEAD)
    return LESSON_PLAN_LEAD;
  return LESSON_PLAN_PROPEL;
};

export const WEBSITE_DATA = {
  headingPart1: "Welcome to the",
  headingPart2: `World Of ${getConfig()?.TITLE} `,
  subHeading: "Designed exclusively for the best schools like yours",
  logo: getConfig()?.LOGO,
  title: `Explore ${getConfig()?.TITLE}`,
  desc: "A comprehensive school system curated to suit the needs of leading schools in the country",
  innderComponents: [
    {
      name: "CP",
      link: "/cp",
      img: getConfig()?.CURRICULUM_PEDAGOGY,
      domains: [
        PRODUCT_TYPE.PINNACLE,
        PRODUCT_TYPE_CAPS.PINNACLE,
        PRODUCT_TYPE.LEAD,
        PRODUCT_TYPE_CAPS.LEAD,
        PRODUCT_TYPE.PROPEL,
        PRODUCT_TYPE_CAPS.PROPEL,
      ],
      components: [
        {
          headingPart1: getConfig().CP_HEADING1,
          headingPart2: getConfig().CP_HEADING2,
          subHeading: `Explore how ${
            getConfig()?.TITLE
          } will make your students future-ready`,
          componentCP: [
            {
              heading: `${getConfig().CORE_SUBJECT} core subject curriculum`,
              subHeading: "One of the best in the country",
              type: TYPES.CARD_MEDIA_CAROUSEL,
              link: "",
              dataList: getConfig()?.CAROUSEL,
              title: "",
              titlePrefix: "",
              titleSuffix: "",
              backgroundImg: "",
              logo: "",
              domains: [
                PRODUCT_TYPE.PINNACLE,
                PRODUCT_TYPE_CAPS.PINNACLE,
                PRODUCT_TYPE.LEAD,
                PRODUCT_TYPE_CAPS.LEAD,
                PRODUCT_TYPE.PROPEL,
                PRODUCT_TYPE_CAPS.PROPEL,
              ],
            },
            {
              heading: `Activity-based learning with ${
                getConfig()?.TITLE
              } Activity Kits`,
              subHeading: `Experience how ${
                getConfig()?.TITLE
              } will ensure your students are learning by doing`,
              img: "",
              type: TYPES.CARD_MEDIA_IMG,
              dataList: [
                {
                  link: getConfig().SCHOOL_ACTIVITY_LINK,
                  img: getConfig().SCHOOL_ACTIVITY,
                },
                {
                  link: getConfig().STUDENT_ACTIVITY_LINK,
                  img: getConfig().STUDENT_ACTIVITY,
                },
              ],
              title: "",
              titlePrefix: "",
              titleSuffix: "",
              backgroundImg: "",
              logo: "",
              domains: [
                PRODUCT_TYPE.PINNACLE,
                PRODUCT_TYPE_CAPS.PINNACLE,
                PRODUCT_TYPE.LEAD,
                PRODUCT_TYPE_CAPS.LEAD,
              ],
            },
            {
              heading: `At-home learning with ${
                getConfig()?.TITLE
              } Student App`,
              subHeading: `Explore how your students can enrich their at-home learning with the ${
                getConfig()?.TITLE
              } Student App`,
              type: TYPES.CARD_LINK,
              dataList: [
                {
                  link: getConfig().SA_PROTOTYPE,
                },
              ],
              img: getConfig()?.STUDENT_APP,
              link: "/saMobile",
              domains: [
                PRODUCT_TYPE.PINNACLE,
                PRODUCT_TYPE_CAPS.PINNACLE,
                PRODUCT_TYPE.LEAD,
                PRODUCT_TYPE_CAPS.LEAD,
              ],
            },
            {
              heading: "Explore More",
              subHeading: "",
              link: "",
              dataList: [
                {
                  type: TYPES.CARD_LINK,
                  link: "/tas",
                  img: getConfig()?.TEACHER_ASSISTANCE_SYSTEM_MINI,
                  domains: [
                    PRODUCT_TYPE.PINNACLE,
                    PRODUCT_TYPE_CAPS.PINNACLE,
                    PRODUCT_TYPE.LEAD,
                    PRODUCT_TYPE_CAPS.LEAD,
                    PRODUCT_TYPE.PROPEL,
                    PRODUCT_TYPE_CAPS.PROPEL,
                  ],
                },
                {
                  type: TYPES.CARD_LINK,
                  img: getConfig()?.SCHOOL_OPERATION_SYSTEM_MINI,
                  link: "/sos",
                  domains: [
                    PRODUCT_TYPE.PINNACLE,
                    PRODUCT_TYPE_CAPS.PINNACLE,
                    PRODUCT_TYPE.LEAD,
                    PRODUCT_TYPE_CAPS.LEAD,
                    PRODUCT_TYPE.PROPEL,
                    PRODUCT_TYPE_CAPS.PROPEL,
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "TAS",
      img: getConfig()?.TEACHER_ASSISTANCE_SYSTEM,
      domains: [
        PRODUCT_TYPE.PINNACLE,
        PRODUCT_TYPE_CAPS.PINNACLE,
        PRODUCT_TYPE.LEAD,
        PRODUCT_TYPE_CAPS.LEAD,
        PRODUCT_TYPE.PROPEL,
        PRODUCT_TYPE_CAPS.PROPEL,
      ],
      components: [
        {
          headingPart1: `${getConfig()?.TITLE}`,
          headingPart2: getConfig().TAS_HEADING2,
          subHeading: `Learn how we assist each of your teachers to teach like the best in the world!`,
          componentCP: [
            {
              heading: "Sample Lesson Plan",
              subHeading: "Use the sample lesson plans along with the books",
              type: TYPES.CARD_LESSON_PLANS,
              domains: [
                PRODUCT_TYPE.PINNACLE,
                PRODUCT_TYPE_CAPS.PINNACLE,
                PRODUCT_TYPE.LEAD,
                PRODUCT_TYPE_CAPS.LEAD,
                PRODUCT_TYPE.PROPEL,
                PRODUCT_TYPE_CAPS.PROPEL,
              ],
              dataList: getLessonPlan(CURRENT_DOMAIN),
            },
            {
              heading: getConfig().SECTION_TITLE_ASM,
              subHeading: `Experience how ${
                getConfig()?.TITLE
              } will enhance the learning experience of each of your students`,
              type: TYPES.CARD_MEDIA_VIDEO,
              domains: [
                PRODUCT_TYPE.PINNACLE,
                PRODUCT_TYPE_CAPS.PINNACLE,
                PRODUCT_TYPE.LEAD,
                PRODUCT_TYPE_CAPS.LEAD,
                PRODUCT_TYPE.PROPEL,
                PRODUCT_TYPE_CAPS.PROPEL,
              ],
              dataList: [
                {
                  heading: "Assessments",
                  timeTakenToComplete: getConfig().TAS_ASM_DURATION,
                  type: TYPES.CARD_MEDIA_VIDEO,
                  link: getConfig()?.TAS_ASM_LINK,
                  img: getConfig()?.ASSESSMENTS,
                  domains: [
                    PRODUCT_TYPE.PINNACLE,
                    PRODUCT_TYPE_CAPS.PINNACLE,
                    PRODUCT_TYPE.PROPEL,
                    PRODUCT_TYPE_CAPS.PROPEL,
                  ],
                },
                {
                  heading: "Remedial",
                  timeTakenToComplete: getConfig().TAS_REMEDIAL_DURATION,
                  type: TYPES.CARD_MEDIA_VIDEO,
                  link: getConfig()?.TAS_REMEDIAL_LINK,
                  img: getConfig()?.REMEDIATION,
                  domains: [
                    PRODUCT_TYPE.PINNACLE,
                    PRODUCT_TYPE_CAPS.PINNACLE,
                    PRODUCT_TYPE.LEAD,
                    PRODUCT_TYPE_CAPS.LEAD,
                  ],
                },
              ],
            },
            {
              heading: "Explore More",
              subHeading: "",
              link: "",
              dataList: [
                {
                  type: TYPES.CARD_LINK,
                  img: getConfig()?.SCHOOL_OPERATION_SYSTEM_MINI,
                  link: "/sos",
                  domains: [
                    PRODUCT_TYPE.PINNACLE,
                    PRODUCT_TYPE_CAPS.PINNACLE,
                    PRODUCT_TYPE.LEAD,
                    PRODUCT_TYPE_CAPS.LEAD,
                    PRODUCT_TYPE.PROPEL,
                    PRODUCT_TYPE_CAPS.PROPEL,
                  ],
                },
                {
                  type: TYPES.CARD_LINK,
                  img: getConfig()?.CURRICULUM_PEDAGOGY_MINI,
                  link: "/cp",
                  domains: [
                    PRODUCT_TYPE.PINNACLE,
                    PRODUCT_TYPE_CAPS.PINNACLE,
                    PRODUCT_TYPE.LEAD,
                    PRODUCT_TYPE_CAPS.LEAD,
                    PRODUCT_TYPE.PROPEL,
                    PRODUCT_TYPE_CAPS.PROPEL,
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "SOS",
      img: getConfig()?.SCHOOL_OPERATION_SYSTEM,
      domains: [
        PRODUCT_TYPE.PINNACLE,
        PRODUCT_TYPE_CAPS.PINNACLE,
        PRODUCT_TYPE.LEAD,
        PRODUCT_TYPE_CAPS.LEAD,
        PRODUCT_TYPE.PROPEL,
        PRODUCT_TYPE_CAPS.PROPEL,
      ],
      components: [
        {
          headingPart1: `${getConfig()?.TITLE}`,
          headingPart2: getConfig().SOS_HEADING2,
          subHeading: `To help you manage your school proactively backed by technology`,
          navLinks: [],
          componentCP: [
            {
              heading: "Teacher Performance",
              subHeading:
                "A quick look at how you can monitor your Teachers' performance",
              type: TYPES.CARD_MEDIA_VIDEO,
              img: TEACHER_VIDEO,
              mediaLink: getConfig().SOS_TEACHER_LINK, // video link
              domains: [
                PRODUCT_TYPE.PINNACLE,
                PRODUCT_TYPE_CAPS.PINNACLE,
                PRODUCT_TYPE.LEAD,
                PRODUCT_TYPE_CAPS.LEAD,
                PRODUCT_TYPE.PROPEL,
                PRODUCT_TYPE_CAPS.PROPEL,
              ],
            },
            {
              heading: "Student Performance",
              subHeading:
                "A quick look at how you can monitor your Students' performance",
              type: TYPES.CARD_MEDIA_VIDEO,
              img: STUDENT_VIDEO,
              mediaLink: getConfig().SOS_STUDENT_LINK, // video link
              domains: [
                PRODUCT_TYPE.PINNACLE,
                PRODUCT_TYPE_CAPS.PINNACLE,
                PRODUCT_TYPE.LEAD,
                PRODUCT_TYPE_CAPS.LEAD,
              ],
            },
            {
              heading: "Explore More",
              subHeading: "",
              link: "",
              dataList: [
                {
                  type: TYPES.CARD_LINK,
                  img: getConfig()?.TEACHER_ASSISTANCE_SYSTEM_MINI,
                  link: "/tas",
                  domains: [
                    PRODUCT_TYPE.PINNACLE,
                    PRODUCT_TYPE_CAPS.PINNACLE,
                    PRODUCT_TYPE.LEAD,
                    PRODUCT_TYPE_CAPS.LEAD,
                    PRODUCT_TYPE.PROPEL,
                    PRODUCT_TYPE_CAPS.PROPEL,
                  ],
                },
                {
                  type: TYPES.CARD_LINK,
                  img: getConfig()?.CURRICULUM_PEDAGOGY_MINI,
                  link: "/cp",
                  domains: [
                    PRODUCT_TYPE.PINNACLE,
                    PRODUCT_TYPE_CAPS.PINNACLE,
                    PRODUCT_TYPE.LEAD,
                    PRODUCT_TYPE_CAPS.LEAD,
                    PRODUCT_TYPE.PROPEL,
                    PRODUCT_TYPE_CAPS.PROPEL,
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const SA_MOBILE_VIEW_CONFIG = [
  {
    type: TYPES.SA_DASHBOARD,
    bgImage: getConfig().SA_DASHBOARD,
    actions: [
      {
        className: "btn-actions btn-subject-tile",
        link: "/saChapter",
      },
      {
        className: "btn-actions btn-learning-resource",
        link: "/saResources",
      },
      {
        className: "btn-actions btn-menu",
        link: "/saMenu",
      },
    ],
  },
  {
    type: TYPES.SA_CHAPTER,
    bgImage: getConfig().SA_CHAPTERS,
    actions: [
      {
        className: "btn-actions btn-content",
        link: "/saContent",
      },
    ],
  },
  {
    type: TYPES.SA_CONTENT,
    bgImage: getConfig().SA_CONTENT,
    actions: [{}],
  },
  {
    type: TYPES.SA_MEDIA,
    bgImage: getConfig().SA_MEDIA,
    actions: [{}],
  },
  {
    type: TYPES.SA_MENU,
    bgImage: getConfig().SA_MENU,
    actions: [
      {
        className: "btn-actions btn-media",
        link: "/saMedia",
      },
    ],
  },
  {
    type: TYPES.SA_RESOURCES,
    bgImage: getConfig().SA_RESOURCES,
    actions: [{}],
  },
];
